import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ProjectService } from "../../../../_services";
import { FormModalComponent } from "../form-modal-component.class";
import { FullProjectHash } from "../../../../_models/project.interface";
import { MailTemplate } from "../../../../_models/mail-template.interface";
import { FormsModule, ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';
import { Observable } from 'rxjs';

@Component({
  selector: 'hawk-add-new-mail-template-modal',
  imports: [
    FormsModule,
    ReactiveFormsModule
  ],
  templateUrl: './add-new-mail-template-modal.component.html',
  standalone: true,
  styleUrls: ['add-new-mail-template-modal.component.scss']
})
export class AddNewMailTemplateModalComponent extends FormModalComponent<MailTemplate, FullProjectHash> {

  @Input() override formGroup: UntypedFormGroup;
  @Output() override closeModal: EventEmitter<void> = new EventEmitter<void>();
  @Output() override newDBOutput: EventEmitter<FullProjectHash>= new EventEmitter<FullProjectHash>();

  constructor(private projectService: ProjectService) {
    super();
  }

  override formGroupToDBInput(): MailTemplate {
    const mailFieldKeys = [
      'orderNr','status','reportLink','dateSLA','operationDate','tasks','priority','dateCreated','externalOrderNr','description',
      'project','store','address','deliveryNotes','contactName','contactEmail','contactPhone','combined_report','operation.date','operation.status',
      'operation.technicians','operation.description','operation.report','operation.travelTimeStart','operation.travelTimeEnd','operation.travelTime',
      'operation.workingTimeStart','operation.workingTimeEnd','operation.workingTime','operation.dateTravelStart','operation.dateOnSite',
      'operation.dateRepaired','operation.dateFinished','operation.distance','operation.files','operation.add_report_photo','operation.dont_send_report'
    ]

    return {
      id: this.formGroup.controls["id"].value,
      project_id: this.formGroup.controls["project_id"].value,
      subject: this.formGroup.controls["subject"].value,
      text: this.formGroup.controls["text"].value,
      type: this.formGroup.controls["type"].value,
      use_dynamic_report: this.formGroup.controls["use_dynamic_report"]?.value || false,
      mail_fields: mailFieldKeys
        .filter((field, index) => this.formGroup.controls[field] && this.formGroup.controls[field].value)
        .map((field, index) => ({ name: field }))
    }
  }

  override getDBCallObservable(create_mail_template_attributes: MailTemplate): Observable<FullProjectHash> {
    return this.projectService.createProjectMailTemplate(
      create_mail_template_attributes.project_id,
      create_mail_template_attributes
    );
  }

}
